/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'alert-circle': {
    width: 16,
    height: 16,
    viewBox: '0 0 32 32',
    data: '<g id="Layer_1"><path pid="0" d="M16 4c6.6 0 12 5.4 12 12s-5.4 12-12 12S4 22.6 4 16 9.4 4 16 4m0-2C8.3 2 2 8.3 2 16s6.3 14 14 14 14-6.3 14-14S23.7 2 16 2z"/><path pid="1" d="M15 7h2v12h-2z"/><circle pid="2" cx="16" cy="22.5" r="1.5"/></g>'
  }
})
